import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const astrologyApi = createApi({
  reducerPath: 'astrologyApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_ASTRO_API_URL,
  }),
  tagTypes: ["PlanetPositions", "PlanetAspects"],
  endpoints: (builder) => ({
    // get designations list
    getPlanetPositions: builder.query({
      query: (data) => ({
        method: "POST",
        url: "/planet-positions",
        body: data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["PlanetPositions"]
    }),
    getPlanetAspects: builder.query({
      query: (data) => ({
        method: "POST",
        url: "/planet-aspects",
        body: data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["PlanetAspects"]
    }),
    getMoonPhases: builder.query({
      query: (data) => ({
        method: "POST",
        url: "/moon-phases",
        body: data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["MoonPhases"]
    })
  }),
})

export const {
  useLazyGetPlanetPositionsQuery,
  useLazyGetPlanetAspectsQuery,
  useLazyGetMoonPhasesQuery,
} = astrologyApi;